module.exports = __webpack_public_path__ + "img/payFail.a20d409e.png";